import { brandHealthDrillResolvers } from './brand-health';
import { communityDrillResolvers } from './community';
import { competitorsDrillResolvers } from './competitors';
import { influencersDrillResolvers } from './influencers';
import { mediaDrillResolvers } from './media';
import { mentionsDrillResolvers } from './mentions';
import { overviewDrillResolvers } from './overview';
import { tablesDrillResolvers } from './tables';
import { trendsDrillResolvers } from './trends';
import type { DrillResolvers } from './types';

export const drillResolvers: DrillResolvers = {
  ...overviewDrillResolvers,
  ...brandHealthDrillResolvers,
  ...communityDrillResolvers,
  ...competitorsDrillResolvers,
  ...mediaDrillResolvers,
  ...mentionsDrillResolvers,
  ...trendsDrillResolvers,
  ...influencersDrillResolvers,
  ...tablesDrillResolvers,
};

export type { DrillResolver, DrillResolvers } from './types';
